const text = (value) => String(value || "").replace(/\s+/g, " ").trim();
const matchKey = (value) => text(value).toLowerCase().replace(/[.,]/g, " ").replace(/\s+/g, " ").trim();

export const resolveBookingImportCustomer = (order, customer, nodes = [], nodeCustomerMap = {}) => {
  const customerKey = matchKey(customer);
  const matchesCustomer = (item) => customerKey &&
    [item.id, item.CustomerNameEN, item.CustomerNameTH].some((value) => matchKey(value) === customerKey);
  const cleanOrder = text(order);
  const prefix = cleanOrder.match(/^(.+?)-SS-/i);
  const orderNodes = prefix
    ? nodes.filter((node) => text(node.nodecode).toLowerCase() === prefix[1].toLowerCase())
    : [];
  let nodeName = orderNodes.length === 1 ? orderNodes[0].nodename : "";

  // Preserve the established order aliases, within the user's allowed nodes.
  if (!nodeName && /^CHG-SS-/i.test(cleanOrder)) nodeName = "Chularat Hospital Group";
  if (!nodeName && /^SS-/i.test(cleanOrder)) nodeName = "Brain Dynamic Technology";
  if (nodeName && !Object.prototype.hasOwnProperty.call(nodeCustomerMap, nodeName)) {
    return { nodeName: "", customerId: "" };
  }

  if (nodeName) {
    const customers = nodeCustomerMap[nodeName] || [];
    const matches = customers.filter(matchesCustomer);
    // The flag uses the full node collection, before staff visibility filtering.
    const resolved = matches.length === 1 ? matches[0] :
      !customerKey && customers.length === 1 && customers[0].isOnlyNodeCustomer
        ? customers[0] : null;
    return {
      nodeName,
      customerId: resolved ? resolved.id : "",
      customerNameEN: resolved ? resolved.CustomerNameEN || "" : "",
    };
  }

  const matches = [];
  Object.keys(nodeCustomerMap).forEach((name) => {
    (nodeCustomerMap[name] || []).filter(matchesCustomer).forEach((item) => {
      matches.push({ nodeName: name, customerId: item.id, customerNameEN: item.CustomerNameEN || "" });
    });
  });
  return matches.length === 1 ? matches[0] : { nodeName: "", customerId: "" };
};
